import CloseIcon from '@mui/icons-material/Close'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, useTheme } from '@mui/material'
import { QueueMessage } from '@src/tools/dead-letter/types/QueueTypes'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  message: QueueMessage | null
  open: boolean
  onClose: () => void
}

function formatContent(content: string): string {
  try {
    return JSON.stringify(JSON.parse(content), null, 2)
  } catch {
    return content
  }
}

const QueueMessageDetailDialog = ({ message, open, onClose }: Props) => {
  const { t } = useTranslation()
  const theme = useTheme()

  if (!message) return null

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth transitionDuration={0} disablePortal>
      <DialogTitle sx={{ borderBottom: '1px solid', textAlign: 'center' }}>
        {t('queues.detailTitle')}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 15, top: 15, color: (th) => th.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Box
          component="pre"
          sx={{
            p: 2,
            borderRadius: 1,
            bgcolor: theme.palette.mode === 'dark' ? 'grey.900' : 'grey.100',
            overflow: 'auto',
            maxHeight: 600,
            fontSize: '0.8rem',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {formatContent(message.content)}
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default memo(QueueMessageDetailDialog)
